<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getChargeDetails)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getChargeDetails)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getChargeDetails, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getChargeDetails, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/chargeSchedule', '产品收费明细统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 收费明细统计列表 -->
      <el-table v-loading="loading" :data="chargeDetailsList" :max-height="tableHeight" border>
        <el-table-column label="药品名称" prop="project" min-width="140"/>
        <el-table-column label="一级分类" prop="type"/>
        <el-table-column label="二级分类" prop="reclassify"/>
        <el-table-column label="药品货号" prop="projectCode"/>
        <el-table-column label="厂家" prop="manufacturer" min-width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.manufacturer.length > 15 ? scope.row.manufacturer.substring(0, 14) + '...' : scope.row.manufacturer }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="规格" prop="specifications"/>
        <el-table-column label="单位" prop="unit"/>
        <el-table-column label="销售数量" prop="number"/>
        <el-table-column label="应收金额(元)" prop="totalPrice" min-width="110"/>
        <el-table-column label="成本(元)" prop="cost"/>
        <el-table-column label="毛利(元)" prop="maoriForehead"/>
        <el-table-column label="毛利率" prop="grossProfitMargin"/>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getChargeDetails)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { chargeDetails } from "@/api/statement"; // 报表统计请求
export default {
  name: 'DrugChargeDetails',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      chargeDetailsList: [], // 收费明细统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getChargeDetails);
  },
  methods: {
    // 请求所有收费明细统计列表
    async getChargeDetails() {
      let { rows, code, total } = await chargeDetails(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.chargeDetailsList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>